import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutGrid2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayoutGrid2"><Path d="M3 3V11H11V3H3Z" fill="currentColor"/><Path d="M13 3V11H21V3H13Z" fill="currentColor"/><Path d="M3 13V21H11V13H3Z" fill="currentColor"/><Path d="M13 13V21H21V13H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutGrid2;
